import { useEffect, useState } from 'react';
import qs from 'query-string';
import { useLocation, useNavigate } from '@reach/router';

import isBrowser from '~/utils/is-browser';
import isEmpty from '~/utils/valid/is-empty';

function useAuth() {
  const [authKey, setAuthKey] = useState('');
  const location = useLocation();
  const { pathname, search } = location;
  const parse = qs.parse(search);

  const navigate = useNavigate();

  useEffect(() => {
    const tempAuthKey = parse?.auth_key || isBrowser() && sessionStorage.getItem('authKey') || '';

    setAuthKey(tempAuthKey);
    delete parse.auth_key;

    if (isBrowser()) {
      sessionStorage.clear();
      sessionStorage.setItem('authKey', tempAuthKey);
    }

    navigate(isEmpty(parse) ? pathname : pathname + `?${qs.stringify(parse)}`, { replace: true });
  }, []);

  return { authKey };
}

export default useAuth;
